import { FormLayout } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import {useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import { getApiData } from "../../helpers/AxiosInstance";
import { createPickupNoteValidationForm} from "../../utils/validationSchemas";
import PickupNoteForm from "./PickupNoteForm";

const EditPickupNote = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [senderId, setSenderId] = useState(null);

  const {
    isLoading,
    data,
    handleUpdate,
    handleMarkAsDone
   
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createPickupNoteValidationForm),
    defaultValues: async () => {
      return {
        ...data,
        note: data?.note,
        piece: data?.piece,
      };
    },
  });




  const handleAutoFill = async (id: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setValue("sender_primary_contact", res?.data?.user_info?.mobile_number);
        setValue("sender_address", res?.data?.default_sender?.address);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (senderId) {
      setValue("merchant", senderId);
      handleAutoFill(senderId);
    }
  }, [senderId]);

  return (
    <>
      <AccessControl
        children={
          <>
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleUpdate}
            setError={setError}
            buttonLabel={"Submit"}
            isLoading={isLoading}
            disabled={data?.is_pickup_note_complete}
          >
            <PickupNoteForm
              register={register}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              watch={watch}
              control={control}
              setSenderId={setSenderId}
            />
          </FormLayout>
          </>
        }
        allowedPermissions={["can_editupdate_pickup_request"]}
      />

    </>
  );
};

export default EditPickupNote;

